import { inject, Inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';
export type ApiGetResult<T> = { data: T; total: number; query: any[] };

@Injectable({
    providedIn: 'root',
})
export class DataService {
    private readonly apiUrl = environment.api_base;

    private readonly http = inject(HttpClient);
    async get<T = any>(path: string, params?: any): Promise<ApiGetResult<T>> {
        const result = await firstValueFrom(this.http.get(`${this.apiUrl}/${path}`, { params }));
        return result as ApiGetResult<T>;
    }
    post<T, R>(path: string, payload: T): Promise<R> {
        return firstValueFrom(this.http.post<R>(`${this.apiUrl}/${path}`, payload));
    }
}
